/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Header } from './header';
import {
  ItemContext,
  ReportContext,
  SectionContext,
} from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import { Table } from './table';
import type { EventReportData } from './types';

export function GoiasaDangersAndRisksReport(props: {
  reportData: EventReportData;
}) {
  return (
    <ReportContext value={props.reportData}>
      <div style={{ breakAfter: 'page' }}>
        {props.reportData.body.items.map((item) => (
          <ItemContext value={item}>
            <div
              style={{
                height: '90%',
                width: '100vw',
                flex: 1,
                backgroundColor: 'white',
                fontFamily: 'sans-serif',
              }}
            >
              {item.sections.map((section) => (
                <SectionContext value={section}>
                  <div
                    style={{
                      margin: '1rem auto',
                      height: 'auto',
                      maxWidth: '64rem',
                    }}
                  >
                    <Header />
                    <div
                      style={{
                        height: '100%',
                        width: '100%',
                        backgroundColor: '#fff',
                      }}
                    >
                      <InitialInfos />
                      <Table />
                    </div>
                  </div>
                </SectionContext>
              ))}
            </div>
          </ItemContext>
        ))}
      </div>
    </ReportContext>
  );
}
